<template>
  <div v-if="Object.keys(selectGame).length > 0">
    <header-game :close="false" :back="true"></header-game>
    <div class="container">
      <div class="home teams">
        <div class="select-team">
          <div class="select-team__title">
            <h3>{{$t('selectTeam.title')}}</h3>
          </div>
          <div class="select-team__teams">
            <div @click="selectTeam('local')" :class="{'active': teamSelected == 'local'}" class="select-team__teams__team">
              <img :src="getUrlShield(selectGame.teamLocal.shield)" alt="" v-if="selectGame.teamLocal.shield != ''">
              <img src="@/assets/shield.svg" alt="" v-else>
              <span>{{selectGame.teamLocal.name}}</span>
            </div>
            <div @click="selectTeam('visitor')" :class="{'active': teamSelected == 'visitor'}" class="select-team__teams__team">
              <img :src="getUrlShield(selectGame.teamVisitor.shield)" alt="" v-if="selectGame.teamVisitor.shield != ''">
              <img src="@/assets/shield.svg" alt="" v-else>
              <span>{{selectGame.teamVisitor.name}}</span>
            </div>
          </div>
          <button class="button button--white" @click="goToSelectAvatar()" :disabled="teamSelected == ''">{{$t("selectTeam.next")}}</button>
        </div>
      </div>
    </div>
    <footer-sponsor></footer-sponsor>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import HeaderGame from '@/components/Header/Game.vue'
import FooterSponsor from '@/components/Footer/Sponsor.vue'

export default {
  components: {
    HeaderGame,
    FooterSponsor
  },
  computed: {
    ...mapState({
      publishedGames: state => state.InfoModule.publishedGames,
      selectGame: state => state.InfoModule.selectGame
    })
  },
  data() {
    return {
      teamSelected: ''
    }
  },
  created() {
    const self = this

    if (Object.keys(self.selectGame).length === 0) {
      this.$store.dispatch('getGame', { id: self.$route.params.id })
    }
  },
  methods: {
    selectTeam(team) {
      this.teamSelected = team
    },
    goToSelectAvatar() {
      const teamId = this.teamSelected == 'local' ? this.selectGame.teamLocal.id : this.selectGame.teamVisitor.id
      // Logic ticketera
      // const paid = this.teamSelected == 'local' ? this.selectGame.localPaid && !this.selectGame.localGrants : this.selectGame.visitorPaid && !this.selectGame.visitorGrants
      // if (paid) {
      //   this.$router.push(`/game/${this.selectGame.id}/ticketera`)
      // } else {
      this.$store.dispatch('getAvatars', { id: teamId })
      this.$router.push(`/game/${this.selectGame.id}/${teamId}/avatar`)
      // }
    },
    getUrlShield(shield) {
      return `${process.env.VUE_APP_CDN_URL_SHIELDS}${shield}`
    }
  },
  watch: {
    selectGame: function() {
      // Verify status game
      if (this.selectGame.status != 'LIVE' && this.selectGame.status != 'NEXT') {
        this.$router.push(`/home/games`)
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.select-team {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 80px 0;

  &__title {
    text-align: center;

    h3 {
      margin: 0;
      color: $white;
      font-weight: 700;
      @include font-settings(kilo, base);
    }
  }

  &__teams {
    display: flex;
    justify-content: space-evenly;
    margin: $margin-mega 0 0;
    align-items: flex-start;
    width: 100%;
    max-width: 480px;

    &__team {
      width: 100%;
      max-width: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: $margin-base;

      img {
        width: 96px;
        min-height: 96px;
      }

      span {
        color: $white;
        text-transform: capitalize;
        margin-top: $margin-base;
        text-align: center;
      }

      &.active {
        background: #ffffff1A;
        border-radius: $redondeadobig;
      }
    }
  }
}
</style>